import { useEffect } from 'react'

const TYPEFORM_URL = 'https://form.typeform.com/to/I917kFxD'

export function ContactPage() {
  useEffect(() => {
    // Redirect to Typeform
    window.location.href = TYPEFORM_URL
  }, [])

  return (
    <div className="container mx-auto px-4 py-20 max-w-4xl text-center">
      <h1 className="text-4xl font-bold mb-8">Contact Us</h1>
      <p className="text-muted-foreground mb-4">
        Redirecting to contact form...
      </p>
      <p className="text-muted-foreground">
        If you are not redirected automatically,{' '}
        <a href={TYPEFORM_URL} className="underline">
          click here
        </a>
      </p>
    </div>
  )
}
